import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'Thankyou.title',
    description: 'Order Confirmation title',
    defaultMessage: 'Thank You for Your Order',
  },
  messagePt1: {
    id: 'Thankyou.messagePt1',
    description: 'Message for the continue shopping button Pt1',
    defaultMessage: `We’ve received your order and will contact you as soon as your
 package is shipped. We have sent a confirmation email to`,
  },
  messagePt2: {
    id: 'Thankyou.messagePt2',
    description: 'Message for the continue shopping button Pt2',
    defaultMessage: `. You
 can also find your purchase information below.`,
  },
  continueShoppingBtnMessage: {
    id: 'Thankyou.continueShoppingBtn.message',
    description: 'Message for the continue shopping button',
    defaultMessage: 'Continue Shopping',
  },
  orderNum: {
    id: 'Thankyou.orderStatus.orderNum',
    description: 'Message for the order status num',
    defaultMessage: 'Order #',
  },
  status: {
    id: 'Thankyou.orderStatus',
    description: 'Message for the order status',
    defaultMessage: 'Status',
  },
  statusProcessing: {
    id: 'Thankyou.orderStatus.statusProcessing',
    description: 'Message for status Processing',
    defaultMessage: 'Processing',
  },
  printOrderConfirmation: {
    id: 'Thankyou.orderStatus.printOrderConfirmation',
    description: 'Message for print order confirmation',
    defaultMessage: 'Print Order Confirmation',
  },
});
